<template>
  <v-card flat>
    <v-card-title class="primary background--text pa-0 ma-0 pa-2">
      <v-icon small color="background" class="pr-2">mdi-check-list</v-icon>
      {{$t('screener.player.playlist.card.title')}}
    </v-card-title>
    <v-data-table :items="screener.films" class="elevation-1" hide-actions hide-headers>
      <template v-slot:items="props">
        <tr
          :class="[
            props.index == currentIndex ?'playing_film' :'',
            'pointer_cursor'
          ]"
          v-if="props.item"
          @click="watchTrailer(props.item, props.index)"
        >
          <td class="px-1" width="5%">
            <v-icon v-if="props.index == currentIndex">
              {{
              "$vuetify.icons.screener_btn_play"
              }}
            </v-icon>
            <div v-else class="subheading">{{ props.index + 1 }}</div>
          </td>
          <td class="pa-1 pa-0 ma-0" width="25%">
            <v-card>
              <v-layout row>
                <v-flex>
                  <template v-if="props.item.thumburls">
                    <v-img min-width="80px" slot="activator" :src="props.item.thumburls" contain></v-img>
                  </template>
                  <template v-else>{{ props.item.title }}</template>
                </v-flex>
              </v-layout>
            </v-card>
          </td>
          <td  width="70%">
            <!-- Producer -->
            <div>
              <span class="body-2 font-weight-medium primary--text">{{ props.item.title }}</span>
            </div>
            <!-- Subtitle -->
            <div>
              <span class="caption font-weight-medium primary--text">{{ props.item.subtitle }}</span>
            </div>
            <!-- Description -->
            <div v-if="showDescription">
              <span class=" ql-editor secondary--text" v-html="props.item.description">{{ props.item.description }}</span>
            </div>
            <!-- Producer -->
            <div v-if="props.item.producer_name">
              <span class="body-1 pr-2 secondary--text">{{ $t("film.producer") }}</span>
              <span class="body-1 font-weight-medium secondary--text">
                {{ props.item.producer_name }}
              </span>
            </div>
            <!-- Director -->
            <div v-if="props.item.director_name">
              <span class="body-1 pr-2 secondary--text">{{ $t("film.director") }}</span>
              <span class="body-1 font-weight-medium secondary--text">
                {{ props.item.director_name  }}
              </span>
            </div>
            <div v-if="showTrailerBtn" class="mt-2">
              <v-btn class="mx-0" small color="primary background--text" dark v-if="props.item.trailer">
                <v-icon small>movie</v-icon>
                &nbsp;{{ $t("screener.btn.watch_trailer") }}
              </v-btn>
            </div>
          </td>

          <!-- <td v-if="showTrailerBtn" class="pa-3 text-xs-right">
            <div>
              <v-btn
                small
                color="primary white--text"
                @click.stop="watchTrailer(props.item)"
              >{{$t('screener.btn.watch.trailer')}}</v-btn>
            </div>
          </td>-->
        </tr>
      </template>
      <template v-slot:no-data>
        <v-layout row wrap justify-center text-xs-center class="pa-5">
          <v-flex xs12 class="py-2 title primary--text">
            {{
            $t("screener.consumer.no_screenings")
            }}
          </v-flex>
          <v-flex xs12 class="py-2">
            <router-link
              class="primary--text subheading"
              :to="{ name: 'screeners.upcoming' }"
            >{{ $t("screener.browse_screenings.title") }}</router-link>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MiniCountDown from "@/components/MiniCountDown";
import { isDateFuture } from "@/helpers";

export default {
  props: {
    screener: {
      type: Object,
      default: null
    },
    showTrailerBtn: {
      type: Boolean,
      default: true
    },
    currentIndex: {
      type: Number,
      default: null
    },
    showDescription: {
      type: Boolean,
      default: false
    }
  },
  name: "FilmList",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      screenings: state => state.consumer.screenings
    }),
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled"
    })
  },
  components: {
    MiniCountDown
  },
  created(){
    this.loadQuillCss();
  },
  methods: {
    loadQuillCss(){
      let link = document.createElement("link");
      link.setAttribute("href", "https://cdn.quilljs.com/1.2.6/quill.snow.css");
      link.setAttribute("rel", "stylesheet");
      document.head.appendChild(link);
    },

    goToWatchPage(screener_id) {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener_id
        }
      });
    },
    watchTrailer(film, index) {
      this.$emit('onMovieClick', index)
      if (film.trailer) {
        this.$emit("watchTrailer", {
          film: film
        });
      }
    },
    goToScreenerOverview(screener_id) {
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: screener_id
        }
      });
    },
    checkScreeningDateIsFuture(scrn_start_date) {
      return isDateFuture(scrn_start_date);
    }
  }
};
</script>
<style scoped>
.playing_film {
  /* background-color: #dddddd; */
}

.pointer_cursor {
  cursor: pointer;
}
</style>


